import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports) => {
			$scope.start = $scope.parameters.start;
			$scope.end   = $scope.parameters.end;

			const financialYear = ReportsService.financialYear();

			if (!$scope.start) {
				$scope.start = financialYear.start;
			}

			if (!$scope.end) {
				$scope.end = financialYear.end;
			}

			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                $scope.reportId,
				title:             'Headcount Summary Report',
				toggleableColumns: false,
			}, {
				ordering: false,
			});
			$scope.data      = [];
			$scope.error     = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start: $scope.start.format(),
					              end:   $scope.end.format(),
				              })
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/AE99CB1E-1AC1-47BB-93A3-C69C3102E17F/index.js